<div class="tw:my-4 tw:rounded-lg tw:bg-primary-50 tw:px-4 tw:py-3">
    <div class="tw:mb-4 tw:flex tw:items-center tw:justify-between">
        <div class="tw:text-lg tw:font-semibold tw:text-primary-500">
            {{ 'SHARED.createBookingModal.collectedPayments' | translate }}
        </div>
    </div>

    @if (payments.length) {
        <div class="tw:text-sm">
            @for (payment of payments; track payment.id ?? $index) {
                <div
                    class="tw:border-t tw:border-primary-100 tw:py-3 tw:text-success-800 tw:flex tw:items-center tw:justify-between"
                >
                    <div class="tw:font-semibold">
                        {{ payment.paymentMethod | paymentMethod: payment.isOnlinePayment }}
                        @if (payment.paidAt) {
                            ({{ payment.paidAt | date: 'short' }})
                        }
                    </div>
                    <div class="tw:font-semibold">+{{ payment.amount | merchantCurrency }}</div>
                </div>
            }
            @if (sale.tip > 0) {
                <div
                    class="tw:border-t tw:border-primary-100 tw:py-3 tw:text-success-800 tw:flex tw:items-center tw:justify-between"
                >
                    <div class="tw:font-semibold">{{ 'SALE_DETAILS.tip' | translate }}</div>
                    <div class="tw:font-semibold">+{{ sale.tip | merchantCurrency }}</div>
                </div>
            }
        </div>
    }

    @if (sale?.missingPayment > 0) {
        <div class="tw:text-error-800 tw:flex tw:justify-between tw:border-t tw:border-primary-100 tw:py-3 tw:text-sm">
            <div class="tw:font-semibold">{{ 'SALES_STATUS.pending' | translate }}</div>
            <div class="tw:font-semibold">{{ sale.missingPayment | merchantCurrency }}</div>
        </div>
    }

    <div class="tw:flex tw:justify-between tw:border-t tw:border-primary-100 tw:py-3 tw:text-sm tw:text-neutral-500">
        <div class="tw:font-semibold">{{ 'SHARED.createBookingModal.totalPaid' | translate }}</div>
        <div class="tw:font-semibold">{{ totalPaid | merchantCurrency }}</div>
    </div>
</div>
